import {readCookie} from '@Utils/cookie.util';

export enum BgRemoverUpsellVariant {
  A = 'new_bgremover_a',
  B = 'new_bgremover_b',
}

/**
 * Mirrors SplitTest::BG_REMOVER_UPSELL_AB_TEST_ID. Both halves of a JS split test have to name the
 * experiment — the backend to key the cookie it writes, the frontend to read that cookie back.
 */
const BG_REMOVER_UPSELL_AB_TEST_ID = '9c2bd5965460c1bfb0afc46ad64279fe';

const SPLIT_TEST_COOKIE_PREFIX = 'evk_';

/**
 * The split-test infrastructure numbers arms from 0, and GTM reads the raw cookie value, so the arm
 * numbers rather than the dialog names are what analytics sees.
 */
const SPLIT_TEST_ARM_A = '0';
const SPLIT_TEST_ARM_B = '1';

export const isBgRemoverUpsellVariant = (value: unknown): value is BgRemoverUpsellVariant => {
  return typeof value === 'string' && Object.values<string>(BgRemoverUpsellVariant).includes(value);
};

/**
 * Reads the arm assigned by the split-test infrastructure, which writes `evk_<experimentId>` in the
 * cache-override hook on every page the experiment is registered against.
 *
 * Returns null when there is no cookie, which is how the experiment is switched off: unregister it
 * from SplitTestFacade and every caller falls back to the generic premium upsell dialog. The cookie
 * is deliberately the only source — `PMW.VARIATION_NUMBER` cannot be trusted for a JS experiment,
 * because on the request that assigns the arm the hook has only queued a Set-Cookie header, so the
 * PHP side sees no cookie yet and rolls its own independent number for that one render.
 */
export const getBgRemoverUpsellVariant = (): BgRemoverUpsellVariant | null => {
  const arm = readCookie(SPLIT_TEST_COOKIE_PREFIX + BG_REMOVER_UPSELL_AB_TEST_ID);

  if (arm === SPLIT_TEST_ARM_A) {
    return BgRemoverUpsellVariant.A;
  }

  if (arm === SPLIT_TEST_ARM_B) {
    return BgRemoverUpsellVariant.B;
  }

  return null;
};
